import { render, staticRenderFns } from "./GroupMemberList.vue?vue&type=template&id=56986020"
import script from "./GroupMemberList.vue?vue&type=script&lang=js"
export * from "./GroupMemberList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports